/* ============================================================
   Bimmer House — product.js
   Variant selection, gallery, qty, tabs, sticky ATC, bundle.
   Loaded by the product sections. Idempotent + editor-safe.
   ============================================================ */
(function () {
  'use strict';
  var BH = window.BimmerHouse || {};

  /* ---------- Main product (gallery + variants + ATC) -------- */
  function initProduct(root) {
    if (!root || root.dataset.bhBound) return;
    root.dataset.bhBound = '1';

    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var optionSelectors = root.querySelectorAll('[data-option-selector]');
    var strings = {};
    var variants = [];
    try { strings = JSON.parse(root.querySelector('[data-variant-strings]').textContent); } catch (e) {}
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}

    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var availEl = root.querySelector('[data-availability]');
    var atcBtn = root.querySelector('[data-atc]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');

    function selectedOptions() {
      var opts = [];
      optionSelectors.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        if (checked) opts[idx] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var info = strings[v.id] || {};

      if (priceEl && info.price) priceEl.textContent = info.price;
      if (compareEl) {
        if (info.compare) { compareEl.textContent = info.compare; compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (atcPrice && info.price) atcPrice.textContent = info.price;
      if (stickyPrice && info.price) stickyPrice.textContent = info.price;

      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available
          ? (atcBtn.getAttribute('data-label') + ' — ' + (info.price || ''))
          : (atcBtn.getAttribute('data-soldout') || 'Sold out');
      }
      if (availEl && info.availability) availEl.textContent = info.availability;

      // Reflect in URL
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      // Swap gallery to the variant's media
      if (v.featured_media && v.featured_media.id) selectMediaById(v.featured_media.id);
    }

    optionSelectors.forEach(function (group) {
      group.addEventListener('change', update);
    });

    /* ---- Gallery ---- */
    var mainImg = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function selectThumb(btn) {
      if (!mainImg || !btn) return;
      mainImg.src = btn.getAttribute('data-full');
      if (btn.getAttribute('data-srcset')) mainImg.srcset = btn.getAttribute('data-srcset');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
    }
    function selectMediaById(id) {
      thumbs.forEach(function (t) {
        if (t.getAttribute('data-media-id') === String(id)) selectThumb(t);
      });
    }
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { selectThumb(btn); });
    });

    /* ---- Quantity ---- */
    var qtyInput = root.querySelector('[data-qty-input]');
    var dec = root.querySelector('[data-qty-minus]');
    var inc = root.querySelector('[data-qty-plus]');
    if (dec && qtyInput) dec.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    if (inc && qtyInput) inc.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    /* ---- Installation request (line item properties) ---- */
    var installBox = root.querySelector('[data-install-request]');
    var installToggle = installBox ? installBox.querySelector('[data-install-toggle]') : null;
    if (installBox && installToggle) {
      var installFields = installBox.querySelector('[data-install-fields]');
      var installInputs = installBox.querySelectorAll('[data-install-prop]');
      var syncInstall = function () {
        var on = installToggle.checked;
        if (installFields) installFields.hidden = !on;
        installInputs.forEach(function (i) { i.disabled = !on; });
      };
      installToggle.addEventListener('change', syncInstall);
      syncInstall();
    }

    function installProperties() {
      if (!installBox || !installToggle || !installToggle.checked) return null;
      var props = {};
      installBox.querySelectorAll('[data-install-prop]').forEach(function (inp) {
        var m = inp.name && inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value) props[m[1]] = inp.value;
      });
      return props;
    }

    /* ---- Tabs ---- */
    var tabBtns = root.querySelectorAll('[data-tab-btn]');
    var tabPanels = root.querySelectorAll('[data-tab-panel]');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-tab-btn');
        tabBtns.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        tabPanels.forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== key; });
      });
    });

    /* ---- AJAX add to cart (form + sticky) ---- */
    function addCurrent(qtyOverride) {
      var id = idInput ? idInput.value : null;
      if (!id) return;
      var qty = qtyOverride || (qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1);
      var title = root.getAttribute('data-product-title') || 'Item';
      var item = { id: id, quantity: qty };
      if (installToggle && installToggle.checked) {
        var dateInput = installBox.querySelector('[data-install-date]');
        if (dateInput && !dateInput.value) {
          BH.toast('Pick a preferred install date first');
          try { dateInput.focus(); } catch (e) {}
          return;
        }
        var props = installProperties();
        if (props) item.properties = props;
      }
      var announce = title + ' added to cart';
      if (item.properties) announce = title + ' + install request added to cart';
      BH.addToCart(item, announce);
    }
    // Bind to the add button's click (NOT form submit) so Shopify's dynamic
    // checkout / accelerated payment buttons keep their native behaviour.
    if (atcBtn) atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      addCurrent();
    });
    var stickyBtn = root.querySelector('[data-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addCurrent(); });

    update();
  }

  /* ---------- Frequently-bought bundle ----------------------- */
  function initBundle(root) {
    if (!root || root.dataset.bhBound) return;
    root.dataset.bhBound = '1';
    var rows = root.querySelectorAll('[data-bundle-row]');
    var totalEl = root.querySelector('[data-bundle-total]');
    var addBtn = root.querySelector('[data-bundle-add]');

    function recalc() {
      var total = 0;
      rows.forEach(function (r) {
        if (r.getAttribute('aria-checked') === 'true') total += parseInt(r.getAttribute('data-price'), 10) || 0;
      });
      if (totalEl) totalEl.textContent = formatMoney(total, root.getAttribute('data-money-format'));
    }
    rows.forEach(function (r) {
      r.addEventListener('click', function () {
        if (r.getAttribute('data-required') === 'true') return;
        r.setAttribute('aria-checked', r.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
        recalc();
      });
      r.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); r.click(); }
      });
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      var items = [];
      rows.forEach(function (r) {
        if (r.getAttribute('aria-checked') === 'true' && r.getAttribute('data-variant-id')) {
          items.push({ id: r.getAttribute('data-variant-id'), quantity: 1 });
        }
      });
      if (items.length) BH.addToCart(items, 'Bundle added to cart');
    });
    recalc();
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (format && format.indexOf('amount_no_decimals') > -1) {
      value = Math.round(cents / 100).toLocaleString('en-US');
    }
    return '$' + value;
  }

  /* ---------- Boot + editor lifecycle ------------------------ */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-section]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-bundle]').forEach(initBundle);
  }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
